<div class="prospection-dashboard">

  <!-- En-tête -->
  <div class="page-header">
    <div>
      <h1>Prospection B2B</h1>
      <p class="sous-titre" *ngIf="stats">
        Période du {{ stats.date_debut | date: 'dd/MM/yyyy' }}
        au {{ stats.date_fin | date: 'dd/MM/yyyy' }}
      </p>
    </div>
    <div class="header-actions">
      <p-selectButton
        [options]="optionsPeriode"
        [(ngModel)]="periode"
        (onChange)="changerPeriode()"
        optionLabel="label"
        optionValue="value"
        [allowEmpty]="false"
      ></p-selectButton>
      <button
        pButton
        type="button"
        icon="pi pi-refresh"
        class="p-button-text"
        pTooltip="Rafraîchir"
        (click)="charger()"
      ></button>
      <button
        pButton
        type="button"
        label="Voir les prospects"
        icon="pi pi-building"
        routerLink="/cac/prospection/entreprises"
      ></button>
    </div>
  </div>

  <!-- Compte à rebours échéance prévoyance -->
  <div class="bandeau-echeance" [class.urgent]="joursAvantEcheance <= 45">
    <i class="pi pi-clock"></i>
    <span>
      <strong>{{ joursAvantEcheance }} jours</strong> avant le 31 octobre — date limite de
      dénonciation d'un contrat de <strong>prévoyance collective</strong> à échéance
      au 31/12 (préavis de 2 mois). La santé collective, elle, reste résiliable à tout
      moment après 12 mois.
    </span>
  </div>

  <p-message
    *ngIf="erreur"
    severity="error"
    [text]="erreur"
    styleClass="pleine-largeur"
  ></p-message>

  <div class="zone-chargement" *ngIf="loading && !stats">
    <p-progressSpinner strokeWidth="4"></p-progressSpinner>
  </div>

  <ng-container *ngIf="stats">

    <!-- Alertes de pilotage -->
    <div class="alertes" *ngIf="stats.alertes.length">
      <p-message
        *ngFor="let alerte of stats.alertes"
        severity="warn"
        [text]="alerte"
        styleClass="pleine-largeur"
      ></p-message>
    </div>

    <!-- Indicateurs de base -->
    <div class="grille-kpi">
      <div class="carte-kpi">
        <span class="kpi-libelle">Prospects en base</span>
        <span class="kpi-valeur">{{ stats.funnel.prospects_en_base | number }}</span>
      </div>
      <div class="carte-kpi accent">
        <span class="kpi-libelle">
          Travaillables
          <i class="pi pi-info-circle" pTooltip="Score ≥ 60 et non exclus"></i>
        </span>
        <span class="kpi-valeur">{{ stats.funnel.travaillables | number }}</span>
      </div>
      <div class="carte-kpi">
        <span class="kpi-libelle">En séquence</span>
        <span class="kpi-valeur">{{ stats.funnel.en_sequence | number }}</span>
      </div>
      <div class="carte-kpi">
        <span class="kpi-libelle">Rendez-vous</span>
        <span class="kpi-valeur">{{ stats.funnel.rdv_pris | number }}</span>
      </div>
      <div class="carte-kpi succes">
        <span class="kpi-libelle">Convertis en CRM</span>
        <span class="kpi-valeur">{{ stats.funnel.convertis | number }}</span>
      </div>
      <div class="carte-kpi" [class.danger]="stats.funnel.oppositions > 0">
        <span class="kpi-libelle">
          Oppositions RGPD
          <i class="pi pi-info-circle" pTooltip="Contacts définitivement exclus de tout canal"></i>
        </span>
        <span class="kpi-valeur">{{ stats.funnel.oppositions | number }}</span>
      </div>
    </div>

    <div class="grille-double">

      <!-- Entonnoir -->
      <div class="bloc">
        <h2>Entonnoir de la période</h2>
        <div class="entonnoir">
          <div class="etape" *ngFor="let etape of entonnoir" [class.alerte]="etape.alerte">
            <div class="etape-tete">
              <span class="etape-libelle">{{ etape.libelle }}</span>
              <span class="etape-valeur">{{ etape.valeur | number }}</span>
            </div>
            <div class="etape-taux" *ngIf="etape.taux !== undefined">
              <span class="taux">{{ etape.taux }} %</span>
              <span class="taux-detail">{{ etape.suffixeTaux }}</span>
              <span class="taux-cible">cible {{ etape.cible }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="colonne">

        <!-- Quotas du jour -->
        <div class="bloc">
          <h2>
            Vos quotas du jour
            <i
              class="pi pi-info-circle"
              pTooltip="Dépasser ces plafonds fait restreindre le compte LinkedIn et dégrade la délivrabilité du domaine d'envoi"
            ></i>
          </h2>

          <div class="quota">
            <div class="quota-tete">
              <span>Invitations LinkedIn</span>
              <span class="quota-chiffres">
                {{ stats.quotas.invitations_aujourdhui }} / {{ stats.quotas.invitations_plafond }}
              </span>
            </div>
            <p-progressBar
              [value]="pourcentageQuota(stats.quotas.invitations_aujourdhui, stats.quotas.invitations_plafond)"
              [showValue]="false"
              [styleClass]="'quota-' + severiteQuota(stats.quotas.invitations_aujourdhui, stats.quotas.invitations_plafond)"
            ></p-progressBar>
          </div>

          <div class="quota">
            <div class="quota-tete">
              <span>Emails envoyés</span>
              <span class="quota-chiffres">
                {{ stats.quotas.emails_aujourdhui }} / {{ stats.quotas.emails_plafond }}
              </span>
            </div>
            <p-progressBar
              [value]="pourcentageQuota(stats.quotas.emails_aujourdhui, stats.quotas.emails_plafond)"
              [showValue]="false"
              [styleClass]="'quota-' + severiteQuota(stats.quotas.emails_aujourdhui, stats.quotas.emails_plafond)"
            ></p-progressBar>
          </div>

          <div class="quota">
            <div class="quota-tete">
              <span>Appels passés</span>
              <span class="quota-chiffres">{{ stats.quotas.appels_aujourdhui }}</span>
            </div>
            <p class="note-quota">
              Uniquement des contacts ayant répondu par écrit — l'API refuse tout autre appel.
            </p>
          </div>
        </div>

        <!-- Santé des canaux -->
        <div class="bloc">
          <h2>Santé des canaux</h2>
          <div class="ligne-metrique">
            <span>Acceptation LinkedIn</span>
            <p-tag
              [value]="stats.taux.taux_acceptation_linkedin + ' %'"
              [severity]="stats.taux.taux_acceptation_linkedin >= 25 ? 'success' : 'warn'"
            ></p-tag>
          </div>
          <div class="ligne-metrique">
            <span>Réponse email</span>
            <p-tag
              [value]="stats.taux.taux_reponse_email + ' %'"
              [severity]="stats.taux.taux_reponse_email >= 4 ? 'success' : 'warn'"
            ></p-tag>
          </div>
          <div class="ligne-metrique">
            <span>
              Bounce
              <i class="pi pi-exclamation-triangle" pTooltip="Au-delà de 3 %, risque de blacklist du domaine"></i>
            </span>
            <p-tag
              [value]="stats.taux.taux_bounce + ' %'"
              [severity]="severiteBounce(stats.taux.taux_bounce)"
            ></p-tag>
          </div>
          <div class="ligne-metrique">
            <span>RDV → conversion</span>
            <p-tag [value]="stats.taux.taux_conversion + ' %'" severity="info"></p-tag>
          </div>
        </div>

      </div>
    </div>

    <!-- Répartitions -->
    <div class="grille-repartitions">

      <div class="bloc">
        <h2>Par produit d'attaque</h2>
        <div class="barre-repartition" *ngFor="let item of stats.par_produit">
          <div class="barre-tete">
            <span>{{ libelleProduit(item.cle) }}</span>
            <span class="barre-total">{{ item.total | number }}</span>
          </div>
          <div class="barre-fond">
            <div class="barre-valeur" [style.width.%]="partRepartition(item, stats.par_produit)"></div>
          </div>
        </div>
        <p class="bloc-vide" *ngIf="!stats.par_produit.length">Aucun prospect scoré.</p>
      </div>

      <div class="bloc">
        <h2>Par statut</h2>
        <div class="barre-repartition" *ngFor="let item of stats.par_statut">
          <div class="barre-tete">
            <span>{{ libelleStatut(item.cle) }}</span>
            <span class="barre-total">{{ item.total | number }}</span>
          </div>
          <div class="barre-fond">
            <div class="barre-valeur" [style.width.%]="partRepartition(item, stats.par_statut)"></div>
          </div>
        </div>
        <p class="bloc-vide" *ngIf="!stats.par_statut.length">Aucun prospect en base.</p>
      </div>

      <div class="bloc">
        <h2>Par secteur</h2>
        <p-table [value]="stats.par_secteur" styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="260px">
          <ng-template pTemplate="header">
            <tr>
              <th>Secteur</th>
              <th class="colonne-nombre">Prospects</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <td>{{ item.libelle }}</td>
              <td class="colonne-nombre">{{ item.total | number }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr><td colspan="2" class="bloc-vide">Aucun secteur renseigné.</td></tr>
          </ng-template>
        </p-table>
      </div>

      <div class="bloc">
        <h2>Par département</h2>
        <p-table [value]="stats.par_departement" styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="260px">
          <ng-template pTemplate="header">
            <tr>
              <th>Département</th>
              <th class="colonne-nombre">Prospects</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <td>{{ item.cle }}</td>
              <td class="colonne-nombre">{{ item.total | number }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr><td colspan="2" class="bloc-vide">Aucun département renseigné.</td></tr>
          </ng-template>
        </p-table>
      </div>

    </div>
  </ng-container>
</div>
